/* =============================================================================
 * Renovacao do token de autenticacao.
 *
 * O backend nao tem refresh token: renovar significa reautenticar com login e
 * senha (ver a divida tecnica documentada em sessao/sessao.js).
 *
 * Single-flight: se dez chamadas descobrirem ao mesmo tempo que o token venceu,
 * apenas UMA reautenticacao acontece e as dez esperam por ela. Sem isso, abrir
 * uma tela com varios blocos dispararia varios logins em paralelo.
 * ========================================================================== */

import { executarFuncionalidade, registrarRenovadorDeToken, tokenAindaValido } from './ServicoAplicacao.js';
import { sessao, aplicarAutenticacao, credencialGuardada, encerrar } from '@shared/sessao/sessao.js';
import { ErroTokenExpirado } from '@shared/lib/erros.js';

let renovacaoEmAndamento = null;

export function renovar({ forcar = false } = {}) {
    if (renovacaoEmAndamento) return renovacaoEmAndamento;
    if (!forcar && tokenAindaValido()) return Promise.resolve();

    renovacaoEmAndamento = (async () => {
        const credencial = credencialGuardada();
        if (!credencial) {
            encerrar({ motivo: 'expirada' });
            throw new ErroTokenExpirado();
        }

        const resultado = await executarFuncionalidade(
            {
                NomeFuncionalidade: 'AutentificarUsuario',
                Login: credencial.login,
                Senha: credencial.senha,
            },
            //semToken quebra a recursao: esta chamada nunca tenta se renovar.
            { semToken: true }
        );

        if (!resultado?.Usuario) {
            encerrar({ motivo: 'expirada' });
            throw new ErroTokenExpirado({ MensagemUsuario: resultado?.Mensagem });
        }

        aplicarAutenticacao(resultado, {
            manterConectado: !!sessao.usuario,
            senha: credencial.senha,
        });
    })().finally(() => {
        renovacaoEmAndamento = null;
    });

    return renovacaoEmAndamento;
}

/** Chamado uma vez no boot: liga o renovador ao cliente sem criar ciclo de import. */
export function instalarRenovacaoAutomatica() {
    registrarRenovadorDeToken(renovar);
}
